// Módulo deliberadamente sem NENHUM import de Firebase (nem direto, nem
// transitivo) — só lógica pura. Ficava em whatsapp.model.ts, mas esse
// arquivo importa services/firebase/firebaseInit.js, que roda getAuth() no
// top-level do módulo e quebra em teste (CI não tem .env, e
// REACT_APP_FIREBASE_apiKey undefined faz o SDK do Firebase lançar
// "auth/invalid-api-key" já na importação, não numa chamada específica) —
// achado real ao abrir a primeira PR de teste pra este código. Qualquer
// função nova aqui tem que continuar sem depender de Firebase, IndexedDB,
// window, etc — é o que garante que dá pra testar sem emulador/mocks.

// Regra única de "essa conversa é minha" — compartilhada entre a lista de
// conversas (Whatsapp.page.tsx) e as notificações (whatsappNotifications.tsx),
// reexportada por model/whatsapp.model.ts. Extraída depois de um bug real: a
// lista já filtrava certo (conversa atribuída a OUTRO atendente não aparece
// mais pra mim), mas a notificação tinha a MESMA regra duplicada só que
// faltando — notificava todo mundo da empresa pra qualquer conversa, mesmo
// já atribuída a outro atendente. Nunca reimplemente esse filtro inline de
// novo — importe daqui.
export function isConversationVisibleToAgent(
  conversation: { assignedAgentId: string | null; queueId: string },
  myId: string,
  myQueueIds: Set<string>,
): boolean {
  return (
    conversation.assignedAgentId === myId ||
    (!conversation.assignedAgentId && myQueueIds.has(conversation.queueId))
  );
}

// Mesmo critério de "participo dessa fila" usado em toda parte que precisa
// saber quais filas um atendente atende (Whatsapp.page.tsx e
// whatsappNotifications.tsx) — tipo estrutural mínimo em vez de importar
// `Queue` de model/queue.model.ts só por causa disso.
export function computeMyQueueIds(
  queues: { id?: string; participants?: { id?: string }[] }[],
  myId: string,
): Set<string> {
  return new Set(
    queues
      .filter((q) => (q.participants || []).some((p) => p.id === myId))
      .map((q) => q.id)
      .filter((id): id is string => !!id),
  );
}
